// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
`;
Header.displayName = 'S.Header';

export const Title = styled.div`
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  margin-right: 8px;
`;
Title.displayName = 'S.Title';

export const Spacer = styled.div`
  flex-grow: 1;
`;
Spacer.displayName = 'S.Spacer';
